export default {
  download: JSON.parse(localStorage.getItem('download-manage-dimension')) ?? {},
  upload: JSON.parse(localStorage.getItem('upload-manage-dimension')) ?? {},
};
